import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '@shared';

export const permissionGuard: CanActivateFn = (route) => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);
  const requiredPermissions = route.data?.['permissions'] as string[] | undefined;

  if (!requiredPermissions?.length) {
    return true;
  }

  if (permissionsService.hasAnyPermission(...requiredPermissions)) {
    return true;
  }

  return router.createUrlTree(['/main/dashboard']);
};
